import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { FindRulesRequest } from '../../models/find-rules.model'
import { RuleCode, Rules, RulesAppliedTo } from '../../models/rules.model'

const RULES_HOST = `helios-rules`
const RULES_FILTERED = `${RULES_HOST}/filtered`
const RULES_APPLIED_TO_URL = `${RULES_HOST}/ruleAppliedTo`

@Injectable({
  providedIn: 'root',
})
export class RulesService {
  constructor(private readonly httpClient: HttpClient) {}

  getRules(): Observable<Rules[]> {
    return this.httpClient.get<Rules[]>(RULES_HOST)
  }

  getFilteredRules(params: FindRulesRequest): Observable<Rules[]> {
    return this.httpClient.post<Rules[]>(`${RULES_FILTERED}`, params)
  }

  getRuleCode(ruleId: number): Observable<RuleCode> {
    return this.httpClient.get<RuleCode>(`${RULES_HOST}/${ruleId}`)
  }

  getRuleAppliedTo(ruleId: number): Observable<RulesAppliedTo[]> {
    return this.httpClient.get<RulesAppliedTo[]>(
      `${RULES_APPLIED_TO_URL}/${ruleId}`,
    )
  }
}
